import { render, staticRenderFns } from "./DevTools.vue?vue&type=template&id=fa41b41c&scoped=true"
import script from "./DevTools.vue?vue&type=script&lang=js"
export * from "./DevTools.vue?vue&type=script&lang=js"
import style0 from "./DevTools.vue?vue&type=style&index=0&id=fa41b41c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa41b41c",
  null
  
)

export default component.exports